module.exports = __webpack_public_path__ + "static/media/ikona-kalendarz-rozowa.b57c672e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ikona-kalendarz-rozowa.svg
// module id = 524
// module chunks = 0